import controller from '../../../../Scripts/Controller.js';
import loadScript from '../../../../Scripts/Util/loadScript.js';

function InstagramBlock(element) {

    var url = "https://5p4rk13.com/LiveFeed/14534/loaderscript.js";

    function init() {
        
        this.isInitialized = false;

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!this.isInitialized && entry.isIntersecting) {
                    this.isInitialized = true;
                    this.observer.unobserve(element);
                    loadScript(url);
                }
            });
        });

        this.observer.observe(element);
    }

    return {
        init: init
    }
}

controller.add('InstagramBlock', InstagramBlock);

export default InstagramBlock;
